import React from 'react';
import { cx } from '../cx';

// temp_TileButton — 임시 공통 컴포넌트(UI파트 검수 후 승격 대상). 처음 쓴 곳: 인디포트폴리오 AI 시공사례.
// 눌러서 고르는 미리보기 타일 — 템플릿·테마·도형·스티커·색 견본·페이지 썸네일처럼 "그림 자체가 버튼"인 자리.
// 기존 표준으로 안 되는 이유: Button 은 글자 버튼, ChoiceCard 는 아이콘 칩 배치 고정, PhotoGrid 는 사진 다중선택 전용.
// 모양(크기·배경·테두리 색)은 소비처 className 이 정한다. 여기서는 버튼 의미와 공통 상태(선택·포커스·비활성)만 맞춘다.
//   선택: aria-pressed=true → 테두리 --gt-primary (소비처에서 aria-pressed: 변형으로 바꿀 수 있다)
export interface TempTileButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** 선택(현재 적용)된 타일 — aria-pressed 로 알린다. 생략하면 토글이 아닌 일반 타일 */
  selected?: boolean;
  /** 평소에도 테두리를 보인다(기본은 투명 테두리 — hover·선택 때만 --gt-primary) */
  bordered?: boolean;
  /** 선택·hover 를 버튼 테두리로 보이지 않는다 — 안쪽 그림(group-aria-pressed: 등)으로 소비처가 직접 표시할 때 */
  plain?: boolean;
}

export const Temp_TileButton = React.forwardRef<HTMLButtonElement, TempTileButtonProps>(function Temp_TileButton(
  { selected, bordered = false, plain = false, className = '', type, children, ...props },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type ?? 'button'}
      aria-pressed={selected == null ? undefined : selected}
      className={cx(
        // 배경·안쪽 여백·글꼴은 preflight 기본(투명·0·상속) — 소비처가 같은 속성 유틸을 겹쳐 쓰지 않게 여기선 주지 않는다
        'group cursor-pointer border-hairline border-solid',
        bordered ? 'border-border' : 'border-transparent',
        !plain && 'hover:border-group aria-pressed:border-group',
        'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-group',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
});
